/**
 * @module DataTable/utils
 * Helper functions for the DataTable component system.
 */

/**
 * Safely retrieves a value from a nested object using a dot-notated path.
 * @example getFieldValue({ user: { name: 'John' } }, 'user.name') // returns 'John'
 */
export const getFieldValue = (obj: unknown, path: string): unknown => {
  if (!obj || !path) return undefined;
  if (path.includes('.')) {
    const keys = path.split('.');
    return keys.reduce(
      (acc: unknown, key) => (acc ? (acc as Record<string, unknown>)[key] : undefined),
      obj,
    );
  }
  return (obj as Record<string, unknown>)[path];
};
